import React, { useState } from 'react';
import styled from 'styled-components';

export const SectionWrapper = styled.div`
  width: 70%;
  height: 100%;
  @media(max-width: 768px) {
    width: 87%;
  }
`;